/**
 * announcement-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class AnnouncementRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.REQ_ANNOUNCEMENT;
	public static tag : MessageTag = MessageTag.REQ_ANNOUNCEMENT;

    constructor (public message : string)
    {
        super();
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/announcement-request.ts